import React from 'react';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { _ } from '_locales';
import { colors } from '_styles';

import { Drawer } from '_components';
import { Details } from '../../DepoEvents_Components';
import oneOf from '../../DepoEvents_Components/helpers';

const Container = styled.div`
  padding: 0;
  height: 100%;
  width: 100%;
  background-color: #fff;
`;

const DetailsComponent = ({ depoEventDetails, details, selectedLang }) => (
  <Container>

    {
      depoEventDetails
        && depoEventDetails.length
        && !depoEventDetails.includes('null')
        ? (
          <>
            <Details tabIndex="-1">
              {parse(depoEventDetails)}
            </Details>
          </>
        ) : null
    }

    {
      details.links.length
        ? (
          details.links.map((link) => (
            <Drawer
              key={`${oneOf(['drop_event_loc_id', 'drop_depot_id'], details)}-${link.drawer_title}`}
              link={link}
              tabIndex="0"
              lang={selectedLang}
            />
          ))
        ) : null
    }
  </Container>
);

export default DetailsComponent;
